module.exports = __webpack_public_path__ + "img/shirato.1df8f9c.jpg";